import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

import Table from "../../components/Table";
import Box from "../../components/Box";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import Input from "../../components/Input";
import InputTextarea from "../../components/InputTextarea";
import InputEditor from "../../components/InputEditor";

import api from "../../services/api";
import { renderError } from "../../helpers/errors";
import { canEditBrands } from "../../services/auth";

// Conjunto fixo de páginas (o rodapé do tema linka os slugs), como no menu
// Páginas do site principal: só edição, cada uma salva no seu modal.
export const PagesTab = ({ brandId }) => {
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [pages, setPages] = useState([]);
    const [data, setData] = useState({ header: [], rows: [] });

    const [editing, setEditing] = useState(null);
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [metaTitle, setMetaTitle] = useState('');
    const [metaDescription, setMetaDescription] = useState('');

    useEffect(() => {
        getPages();
    }, []);

    useEffect(() => {
        generateData();
    }, [pages]);

    const getPages = () => {
        setLoading(true);
        api.get(`/brand/${brandId}/page`).then(res => {
            setPages(res.data.resources ?? []);
        }).catch(error => {
            renderError(error);
        }).then(() => setLoading(false));
    };

    const generateData = () => {
        const header = ['Título', 'Endereço', 'Conteúdo'];
        const rows = pages.map(page => ({
            data: [
                page.title,
                `/${page.slug}`,
                <span className={`brand-status-badge ${page.text ? 'ok' : 'pending'}`}>{page.text ? 'Preenchido' : 'Vazio'}</span>
            ],
            action: () => editPage(page)
        }));

        setData({ header, rows });
    };

    const editPage = page => {
        setEditing(page);
        setTitle(page.title ?? '');
        setText(page.text ?? '');
        setMetaTitle(page.meta_title ?? '');
        setMetaDescription(page.meta_description ?? '');
    };

    const updatePage = () => {
        setSaving(true);

        api.put(`/brand/${brandId}/page/${editing.id}`, {
            title,
            text,
            meta_title: metaTitle,
            meta_description: metaDescription
        }).then(() => {
            toast.success('Página atualizada com sucesso');
            setEditing(null);
            getPages();
        }).catch(error => {
            renderError(error);
        }).then(() => setSaving(false));
    };

    return (
        <div className="brand-pages">
            {editing &&
                <Modal
                    className={`brand-page-modal`}
                    title={`Editar página`}
                    show={true}
                    close={() => setEditing(null)}
                    size={`big`}
                    footer={canEditBrands()
                        ? <Button type={`primary`} size={`small`} text={`Salvar alterações`} svg={`save-white`} action={updatePage} loading={saving} />
                        : null
                    }
                >
                    <div className="section">
                        <div className="row">
                            <div className="col-6">
                                <Input type={`text`} label={`Título`} value={title} change={setTitle} />
                            </div>
                            <div className="col-6">
                                <Input type={`text`} label={`Endereço`} value={`/${editing.slug}`} change={() => {}} disabled={true} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <Input type={`text`} label={`Meta title`} value={metaTitle} change={setMetaTitle} />
                            </div>
                            <div className="col-6">
                                <InputTextarea label={`Meta description`} value={metaDescription} change={setMetaDescription} rows={2} />
                            </div>
                        </div>
                        <h2 className="section-title">Conteúdo da página</h2>
                        <InputEditor value={text} change={setText} />
                    </div>
                </Modal>
            }

            <div className="brand-tab-head">
                <div>
                    <h2 className="section-title">Páginas do site da marca</h2>
                    <p className="section-hint">Textos institucionais linkados no rodapé do site. Clique numa página para editar.</p>
                </div>
            </div>

            <Box className={`no-padding`}>
                <Table header={data.header} rows={data.rows} loading={loading} />
            </Box>
        </div>
    );
};

export default PagesTab;
